import { useAccessPattern } from "@hooks/useAccessPattern";
import { useOpenNewEndorsement } from "@hooks/endorsement";

import type { PolicyDetailsContentProps } from "../../types";

export const useEndorsementAdditionalInterests = (
  policy: PolicyDetailsContentProps["policy"]
) => {
  const { canManageEndorsements } = useAccessPattern();

  const {
    openNewEndorsement,
    isEligibilityLoading,
    blockingReason,
    setBlockingReason,
  } = useOpenNewEndorsement(policy?.policyLocator);

  const handleManageClick = () =>
    openNewEndorsement({ fromAdditionalInterestTab: true });

  const handleIneligibleModalClose = () => setBlockingReason(null);

  return {
    additionalInterests: policy?.additionalInterests ?? [],
    canManageEndorsements,
    isEligibilityLoading,
    blockingReason,
    handleManageClick,
    handleIneligibleModalClose,
  };
};
